import { type FunctionComponent } from "react";
import { graphql, useFragment } from "react-relay";

import { useLiveArticleScrollContext } from "~/components/article/article-render/live-article/contexts";
import { formatInTimeZone } from "~/lib/utils";
import type { itemLiveArticleSummaryLiveContent$key } from "~/queries/__generated__/itemLiveArticleSummaryLiveContent.graphql";

import { Container, StyledBookmarkLogo, Text, Time } from "./styles";

type Props = {
  className?: string;
  reference: itemLiveArticleSummaryLiveContent$key;
};

export const LiveArticleSummaryItem: FunctionComponent<Props> = ({ className, reference }) => {
  const { setScrollItem } = useLiveArticleScrollContext();

  const liveContent = useFragment(
    graphql`
      fragment itemLiveArticleSummaryLiveContent on LiveContent {
        entityUuid
        customTime
        summary {
          text
        }
      }
    `,
    reference,
  );

  const renderTime = () => {
    if (!liveContent?.customTime) return null;
    return <Time>{formatInTimeZone(liveContent.customTime, "h:mma")}</Time>;
  };

  const renderText = () => {
    if (!liveContent?.summary?.text) return null;
    return <Text>{liveContent.summary.text}</Text>;
  };

  return (
    <Container className={className} onClick={() => setScrollItem?.(liveContent?.entityUuid)}>
      <StyledBookmarkLogo height="14px" width="12px" />
      {renderTime()}
      {renderText()}
    </Container>
  );
};

LiveArticleSummaryItem.displayName = "LiveArticleSummaryItem";
